import { useMemo, useState } from "react";
import { Star } from "lucide-react";
import { reviews } from "../TestimonialsCarousel";
import { ArrowControls, HOME_WRAP, SectionEyebrow } from "./HomeShared";
import quoteImage from "../../assets/invertedcomma.svg";

function getVisible(items, start, count) {
  return Array.from({ length: Math.min(count, items.length) }, (_, index) => items[(start + index) % items.length]);
}

function RatingStars({ rating = 5 }) {
  return (
    <>
      {[...Array(5)].map((_, star) => {
        const fill = Math.max(0, Math.min(1, rating - star));

        return (
          <span key={star} className="relative inline-flex">
            <Star className="h-4 w-4 fill-current text-[#e5e7eb]" />
            {fill > 0 ? (
              <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
                <Star className="h-4 w-4 fill-current text-[#ffb800]" />
              </span>
            ) : null}
          </span>
        );
      })}
    </>
  );
}

export default function TestimonialsPreview() {
  const pageSize = 5;
  const [start, setStart] = useState(0);
  const visibleReviews = useMemo(() => getVisible(reviews, start, pageSize), [start]);

  return (
    <section className={`${HOME_WRAP} py-20`}>
      <div className="flex items-end justify-between">
        <div>
          <SectionEyebrow>Kind Words</SectionEyebrow>
          <h2 className="text-[34px] font-bold leading-tight text-[#071746] md:text-[44px]">Stories Behind Every Confident Smile</h2>
        </div>
        <ArrowControls
          label="testimonials"
          onPrev={() => setStart((current) => (current - pageSize + reviews.length) % reviews.length)}
          onNext={() => setStart((current) => (current + pageSize) % reviews.length)}
        />
      </div>
      <div className="mt-8 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {visibleReviews.map((review, index) => (
          <article key={`${review.name}-${start}-${index}`} className={`${index > 2 ? "xl:translate-x-1/2" : ""} rounded-[12px] border border-[#c7cbd3] bg-white p-7`}>
            <img src={quoteImage} alt="" className="h-7 w-10 opacity-70" />
            <p className="-mt-7 ml-14 min-h-[86px] max-w-[330px] text-[14px] leading-relaxed text-[#2d2d2d]">{review.text}</p>
            <div className="mt-7 flex items-center justify-between gap-4">
              <div>
                <div className="flex gap-1">
                  <RatingStars rating={review.rating} />
                </div>
                <p className="mt-2 text-[15px] font-semibold text-black">-{review.name}</p>
                <p className="text-[13px] text-[#666]">{review.role}</p>
              </div>
              <img src={review.img} alt="" className="h-[64px] w-[64px] rounded-full object-cover object-top" />
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
